import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Box, Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, Tab, Tabs, Tooltip, Typography } from '@mui/material'
import { Add, AddCircle, ArrowCircleDown, ArrowDropDown, CameraAlt, HourglassBottom, LocalOffer, Place, Search } from '@mui/icons-material'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'

import person from '../../../../Assets/Imgs/person.png'
import { data2Sql, showNotify } from '../../../../Utils/Utils'
import OneTextArea from '../../../../Components/OneTextArea/OneTextArea'
import HistoricoVisitasModal from '../../../../Components/HistoricoVisitasModal/HistoricoVisitasModal'
import { validarCPF } from '../../../../Utils/tratarCpf'
import get_token from '../../../../Utils/One_Auth'
import { consultaCEP } from '../../../../Utils/tratarCep'
import ConfirmModal from '../../../../Components/ConfirmModal/ConfirmModal'
import AvatarOne from '../../../../Components/AvatarOne/AvatarOne'
import WebCam from '../../../../Components/Webcam/Webcam'
import OneButton from '../../../../Components/OneButton/OneButton'
import OneModal from '../../../../Components/OneModal/OneModal'
import { UserContext } from '../../../../Providers/UserContext/UserContex'
import { TabPanel } from '../../../../Components/TabPanel'

import { LabelSelect } from './components/LabelSelect'
import { LabelInput } from './components/LabelInput'
import OneDatePicker from '../../../../Components/OneDatePicker/OneDatePicker'
import AnexosVisitante from '../../../../Components/AnexosVisitante/AnexosVisitante'

const labelWidth = '62px'
const inputWidth = `calc(100% - ${labelWidth})`
const TypographySx = {
    color: 'black',
    fontSize: '15px'
}

const VisitanteInfo = ({ height }) => {
    const {
        addVisitanteSelecionado,
        visitanteInfo,
        addRoute,
        sendWs,
        novoVisitante,
        criarVisitante,
        editarVisitante,
        activeCond,
        autorizarVisitante,
        localizacaoImoveis,
        enviaLocalizacao
    } = useContext(VisitantesContext)
    const { user } = useContext(UserContext)
    const [imagemVisitante, setImagemVisitante] = useState(false)
    const [criarNovoVisitante, setCriarNovoVisitante] = useState(false)
    const [openHistorico, setOpenHistorico] = useState(false)

    const [historicoVisitante, setHistoricoVisitante] = useState([])
    const [visitantesDados, setVisitantesDados] = useState(null)

    const [disabledComponents, setDisabledComponents] = useState(true)

    const [editModal, setEditModal] = useState(false)
    const [modalCam, setModalCam] = useState(false)

    const [openModalEditTag, setOpenModalEditTag] = useState(false)
    const [openModalAnexosVisitante, setOpenModalAnexosVisitante] = useState(false)

    const [nomeAnexoVisitante, setNomeAnexoVisitante] = useState('')
    const [caminhoAnexoVisitante, setCaminhoAnexoVisitante] = useState('')
    const [propriedadeImagemCapturada, setPropriedadeImagemCapturada] = useState('IMAGEMDOCUMENTO')

    const getImagemDocumentoSrc = useCallback((imagem, propriedade) => {
        console.log('visitantesDados', visitantesDados)
        console.log('getImagemDocumentoSrc', imagem, propriedade)
        if (!imagem || typeof imagem !== 'string') {
            return ''
        }
        const trimmed = imagem.trim()

        if (trimmed.startsWith('data:image')) {
            return trimmed
        }

        if (trimmed.includes('temp')) {
            console.log('getImagemDocumentoSrc1', trimmed)
            return `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web${trimmed.substring(1)}?df=${new Date().getTime()}`
        } else if (trimmed.includes('temp')) {
            console.log('getImagemDocumentoSrc2', trimmed)
            return `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web${trimmed.substring(1)}?df=${new Date().getTime()}`
        }

        const baseOrigin = typeof window !== 'undefined' && window.location ? window.location.origin : ''
        const sanitizedOrigin = baseOrigin ? baseOrigin.replace(':3003', '') : ''

        return `${sanitizedOrigin}/wsOnePortaria/web/images/${trimmed}?df=${new Date().getTime()}`
    }, [])

    const [leitoresFaciais, setLeitoresFaciais] = useState([])

    const [tab, setTab] = useState(0)

    useEffect(() => {
        if (novoVisitante) {
            setCriarNovoVisitante({})
            setDisabledComponents(false)
        } else {
            setCriarNovoVisitante(false)
        }
        getLeitoresFaciais()
    }, [novoVisitante])

    useEffect(() => {
        setImagemVisitante(false)
        if (visitanteInfo) {
            if (visitanteInfo.tag && visitanteInfo.tag != '') {
                setImagemVisitante(`${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${activeCond.id_central}/f${visitanteInfo.CD_ACESSO}.jpg?df=${new Date().getTime()}`)
            }
            setVisitantesDados({
                ...visitanteInfo,
                validade_doc1: visitanteInfo.validade_doc1 ? visitanteInfo.validade_doc1.split('T')[0] : '',
                validade_doc2: visitanteInfo.validade_doc2 ? visitanteInfo.validade_doc2.split('T')[0] : '',
                validade_doc3: visitanteInfo.validade_doc3 ? visitanteInfo.validade_doc3.split('T')[0] : ''
            })
            setDisabledComponents(false)
            window.addEventListener("message", trataIframe, true)
            return () => window.removeEventListener('message', trataIframe, true)
        } else {
            setVisitantesDados({})
            setImagemVisitante(person)
        }
    }, [visitanteInfo])

    useEffect(() => {
        if (autorizarVisitante) {
            handleSalvarAdicionarVisitante()
        }
    }, [autorizarVisitante])

    const trataIframe = (msg) => {
        let origem = window.location.hostname
        if (event.origin.indexOf(origem) === -1) return
        if (msg && msg.data) {
            if (msg.data.cmd == 'obseditartag') {
                if (msg.data.dados.status) {
                    setOpenModalEditTag(false)
                    showNotify('success', 'Tag editada com sucesso!')
                } else {
                    showNotify('error', 'Erro ao editar tag')
                }
            }
        }
    }

    const handleChangeVisitanteDados = (event) => {
        const { name, value } = event.target
        setVisitantesDados({ ...visitantesDados, [name]: value })
    }

    const getHistoricoVisitante = (msg) => {
        if (msg.data.status) {
            const historicoVisitanteBack = msg.data.listaHistorico
            setHistoricoVisitante(historicoVisitanteBack)
            setOpenHistorico(true)
        } else {
            showNotify('error', 'Erro ao buscar histórico de visitas')
        }
    }

    addRoute('listaHistoricoVisitas', getHistoricoVisitante)

    const handleHistoricoVisitante = () => {
        if (visitanteInfo && visitanteInfo.CD_ACESSO) {
            sendWs('listaHistoricoVisitas', { cd_visitante: visitanteInfo.CD_ACESSO })
        } else {
            showNotify('info', 'Procure um visitante para buscar o histórico de visitas')
        }
    }

    const buscarCpf = () => {
        if (visitantesDados.cpf) {
            const valido = validarCPF(visitantesDados.cpf, activeCond.pais)
            if (valido == 'ok') {
                buscarPessoaPorCpf(visitantesDados.cpf)
            } else {
                showNotify('warning', valido)
            }
        } else {
            showNotify('info', `Informe um ${activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'} para buscar`)
        }
    }

    const buscarPessoaPorCpfResposta = (msg) => {
        if (msg.data.status) {
            if (typeof msg.data.visitante == 'string') {
                if (msg.data.cod === "0001") {
                    showNotify('warning', `${activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'} já cadastrado para ${msg.data.pessoal}`)
                }
            } else {
                let visitante = {
                    nome: msg.data.visitante.nome ? msg.data.visitante.nome.substring(0, 50) : '',
                    NASCIMENTO: msg.data.visitante.nascimento ? data2Sql(msg.data.visitante.nascimento) : '',
                    telefone: msg.data.visitante.cels ? msg.data.visitante.cels[0] : ''
                }

                setVisitantesDados({ ...visitantesDados, ...visitante })
            }
        } else {
            showNotify('error', 'Erro ao buscar visitante')
        }
    }

    addRoute('buscarPessoaPorCpf', buscarPessoaPorCpfResposta)

    const buscarPessoaPorCpf = async (cpf) => {
        const visitanteObj = {
            acao: 'buscarPessoaPorCpf',
            cpf,
            id_central: activeCond.id_central
        }

        let token = await get_token()

        sendWs('buscarPessoaPorCpf', { pessoa: visitanteObj, x_access_token: token.token })
    }

    const buscarCep = async () => {
        if (visitantesDados.CEP) {
            const end = await consultaCEP(visitantesDados.CEP)
            if (end) {
                setVisitantesDados({ ...visitantesDados, ENDERECO: end.logradouro })
            }
        } else {
            showNotify('info', `Informe um ${activeCond.pais === 'es-CL' ? 'RUT' : 'CEP'} para buscar`)
        }
    }

    const handleSalvarAdicionarVisitante = () => {
        if (criarNovoVisitante) {
            criarVisitante(visitantesDados)
        } else {
            let visitanteDadosDoc1 = visitantesDados.validade_doc1 ? visitantesDados.validade_doc1.split('T')[0] : ''
            let visitanteDadosDoc2 = visitantesDados.validade_doc2 ? visitantesDados.validade_doc2.split('T')[0] : ''
            let visitanteDadosDoc3 = visitantesDados.validade_doc3 ? visitantesDados.validade_doc3.split('T')[0] : ''

            let visitanteInfoDoc1 = visitanteInfo.validade_doc1 ? visitanteInfo.validade_doc1.split('T')[0] : ''
            let visitanteInfoDoc2 = visitanteInfo.validade_doc2 ? visitanteInfo.validade_doc2.split('T')[0] : ''
            let visitanteInfoDoc3 = visitanteInfo.validade_doc3 ? visitanteInfo.validade_doc3.split('T')[0] : ''

            if (visitantesDados.CEP != visitanteInfo.CEP ||
                visitantesDados.ENDERECO != visitanteInfo.ENDERECO ||
                visitantesDados.NUMERO != visitanteInfo.NUMERO ||
                visitantesDados.telefone != visitanteInfo.telefone ||
                visitantesDados.placa != visitanteInfo.placa ||
                visitantesDados.ID_FUNCAO != visitanteInfo.ID_FUNCAO ||
                visitantesDados.obs != visitanteInfo.obs ||
                visitantesDados.face != visitanteInfo.face ||
                visitanteDadosDoc1 != visitanteInfoDoc1 ||
                visitanteDadosDoc2 != visitanteInfoDoc2 ||
                visitanteDadosDoc3 != visitanteInfoDoc3 ||
                visitantesDados.imgDocumento || visitantesDados.imgDocumento2
            ) {
                setEditModal(true)
            } else {
                addVisitanteSelecionado(visitantesDados)
            }
        }
    }

    const handleCapFoto = (ip_equip) => {
        if (ip_equip == '0.0.0.0') { // webcam
            return handleCapFotoWebCam()
        }

        visitantesDados.capFoto = true
        if (criarNovoVisitante) {
            if (!visitantesDados.cpf || visitantesDados.cpf == '' || !visitantesDados.nome || visitantesDados.nome == '') {
                showNotify('warning', `Preencha os campos ${activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'} e Nome!`)
                return
            }
            criarVisitante(visitantesDados, ip_equip)
        } else {
            // if (visitanteInfo.id_tag && visitanteInfo.id_tag != '' && visitanteInfo.id_tag != null) {
            //     sendCapFoto()
            // } else {
            let visitanteDadosDoc1 = visitantesDados.validade_doc1 ? visitantesDados.validade_doc1.split('T')[0] : ''
            let visitanteDadosDoc2 = visitantesDados.validade_doc2 ? visitantesDados.validade_doc2.split('T')[0] : ''
            let visitanteDadosDoc3 = visitantesDados.validade_doc3 ? visitantesDados.validade_doc3.split('T')[0] : ''

            let visitanteInfoDoc1 = visitanteInfo.validade_doc1 ? visitanteInfo.validade_doc1.split('T')[0] : ''
            let visitanteInfoDoc2 = visitanteInfo.validade_doc2 ? visitanteInfo.validade_doc2.split('T')[0] : ''
            let visitanteInfoDoc3 = visitanteInfo.validade_doc3 ? visitanteInfo.validade_doc3.split('T')[0] : ''

            if (visitantesDados.CEP != visitanteInfo.CEP ||
                visitantesDados.ENDERECO != visitanteInfo.ENDERECO ||
                visitantesDados.NUMERO != visitanteInfo.NUMERO ||
                visitantesDados.telefone != visitanteInfo.telefone ||
                visitantesDados.placa != visitanteInfo.placa ||
                visitantesDados.ID_FUNCAO != visitanteInfo.ID_FUNCAO ||
                visitantesDados.obs != visitanteInfo.obs ||
                visitantesDados.face != visitanteInfo.face ||
                visitanteDadosDoc1 != visitanteInfoDoc1 ||
                visitanteDadosDoc2 != visitanteInfoDoc2 ||
                visitanteDadosDoc3 != visitanteInfoDoc3
            ) {
                setEditModal(true)
            } else {
                editarVisitante(visitantesDados, ip_equip)
            }
            // }
        }
    }

    const handleCapFotoWebCam = () => {
        setModalCam(true)
    }

    const fotoWebCam = (base64img) => {
        setImagemVisitante(base64img)
        setVisitantesDados({ ...visitantesDados, face: base64img, gerarTag: true })
    }

    const handleEditarTag = () => {
        if (visitantesDados && visitantesDados.bloqueado) {
            showNotify('warning', 'Visitante bloqueado! Não é possível editar a tag de um visitante bloqueado!')
            return
        }
        if (visitantesDados && visitantesDados.CD_ACESSO) {
            setOpenModalEditTag(true)
        } else {
            showNotify('info', 'Procure um visitante para editar a tag')
        }
    }

    const getLeitoresFaciais = async () => {
        addRoute('leitores_captura_facial', leitores_captura_facial)
        sendWs('leitores_captura_facial', { id_central: activeCond.id_central })
    }

    const leitores_captura_facial = (msg) => {
        const { status, faciais } = msg?.data
        if (status && faciais) {
            setLeitoresFaciais([...faciais, ...[{ id: 0, id_central: activeCond.id_central, nome: 'WEBCAM', leitorprincipal: false, ip: '0.0.0.0' }]])
        }
    }

    const setAnexoVisitante = (dados) => {
        console.log(dados)
        const { name, value } = dados

        // Mapear o nome da propriedade para o formato correto usado no estado
        let propertyName = name
        if (name === 'imgDocumento') {
            propertyName = 'IMAGEMDOCUMENTO'
        } else if (name === 'imgDocumento2') {
            propertyName = 'IMAGEMDOCUMENTO2'
        }
        // Atualizar o estado com o nome correto da propriedade
        handleChangeVisitanteDados({ target: { name: propertyName, value } })

        handleChangeVisitanteDados({ target: { name, value } })

        // setTimeout(() => {
        //     if (name == 'imgDocumento') {
        //         console.log('setAnexoVisitante1', value)
        //         const imgElement = document.getElementById('imgDocumento')
        //         if (imgElement) {
        //             imgElement.src = getImagemDocumentoSrc(value, 'IMAGEMDOCUMENTO')
        //         }
        //     } else if (name == 'imgDocumento2') {
        //         console.log('setAnexoVisitante2', value)
        //         const imgElement = document.getElementById('imgDocumento2')
        //         if (imgElement) {
        //             imgElement.src = getImagemDocumentoSrc(value, 'IMAGEMDOCUMENTO2')
        //         }
        //     }
        // }, 500)
    }

    const BtnCapturarFacial = () => {
        const options = leitoresFaciais.map((item) => { return (item.facialprincipal ? `${item.nome} - (principal)` : item.nome) })

        const [open, setOpen] = useState(false)
        const anchorRef = useRef(null)

        const getStorage = () => {
            let storage = localStorage.getItem('o_mo_facialselecionado')
            storage = (storage ? JSON.parse(storage) : {})
            return storage
        }

        const setStorage = (storage = false) => {
            if (storage) {
                localStorage.setItem('o_mo_facialselecionado', JSON.stringify(storage))
            }
        }

        const value_storage = (getStorage())[activeCond.id_central] || 0

        const [selectedIndex, setSelectedIndex] = useState(parseInt(value_storage))

        const handleClick = () => {
            let leitor = leitoresFaciais[selectedIndex]
            handleCapFoto(leitor.ip)
        }

        const handleMenuItemClick = (event, index) => {
            setSelectedIndex(index)
            setOpen(false)

            let storage = getStorage()
            storage[activeCond.id_central] = index
            setStorage(storage)
        }

        const handleToggle = () => {
            setOpen((prevOpen) => !prevOpen)
        }

        const handleClose = (event) => {
            if (anchorRef.current && anchorRef.current.contains(event.target)) {
                return
            }

            setOpen(false)
        }

        return (
            <>
                <ButtonGroup
                    variant="outlined"
                    ref={anchorRef}
                    type='button'
                    sx={{
                        color: 'inherit',
                        '& .MuiButtonGroup-grouped': {
                            border: '2px solid white',
                            padding: '0px 2px',
                            minWidth: 'auto'
                        },
                        '& .MuiButtonGroup-grouped:hover': {
                            border: '2px solid white'
                        },
                        '& .MuiButtonBase-root-MuiMenuItem-root': {
                            backgroundColor: '#8A05BE'
                        },
                        marginBottom: '5px'
                    }}
                    size="small"
                    color="primary"
                >
                    <Button onClick={() => { handleClick() }} sx={{
                        padding: '2px',
                        fontSize: '10px',
                        color: 'white',
                        backgroundColor: '#0808088e'
                    }}>
                        <CameraAlt cursor="pointer" sx={{ fontSize: '12px', color: 'white', marginRight: '5px' }} />
                        Capturar
                    </Button>

                    <Button
                        size="small"
                        aria-controls={open ? 'split-button-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="menu"
                        onClick={handleToggle}
                        type='button'
                        sx={{ padding: '0', color: 'white', width: '25px', backgroundColor: '#0808088e' }}
                    >
                        <ArrowDropDown />
                    </Button>
                </ButtonGroup>

                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    transition
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom' ? 'center top' : 'center bottom'
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList id="split-button-menu" autoFocusItem>
                                        {options.map((option, index) => (
                                            <MenuItem
                                                key={option}
                                                selected={index === selectedIndex}
                                                onClick={(event) => handleMenuItemClick(event, index)}
                                                sx={{
                                                    '&:hover': {
                                                        backgroundColor: '#d7fcd7', // Cor de hover
                                                        color: 'black' // Cor do texto no hover
                                                    },
                                                    '&.Mui-selected': {
                                                        backgroundColor: '#afffaf', // Cor do item selecionado
                                                        color: '#0056b3' // Cor do texto do item selecionado
                                                    },
                                                    '&.Mui-selected:hover': {
                                                        backgroundColor: 'rgba(0, 123, 255, 0.3)' // Cor de hover para item selecionado
                                                    }
                                                }}
                                            >
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </>
            // <Tooltip title={"Capturar imagem pelo equipamento facial!"}>

        // </Tooltip>
        )
    }

    const BuscarCepComponent = () => {
        return (
            <Tooltip title={'Buscar Cep'} placement="bottom" arrow>
                <Search
                    onClick={() => { buscarCep() }}
                    sx={{
                        cursor: 'pointer',
                        color: 'black'
                    }}
                />
            </Tooltip>
        )
    }

    const BuscaCPFComponent = () => {
        return (
            <Tooltip title={`Buscar ${activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'}`} placement="bottom" arrow>
                <Search
                    onClick={() => { buscarCpf() }}
                    sx={{
                        cursor: 'pointer',
                        color: 'black'
                    }}
                />
            </Tooltip>
        )
    }

    return (
        <Grid container xs={12} sx={{
            flexDirection: 'row',
            height,
            borderBottom: '1px solid white',
            padding: '5px',
            overflowY: 'auto',
            overflowX: 'hidden',
            boxSizing: 'border-box'
        }}>
            {openHistorico &&
                <HistoricoVisitasModal
                    open={openHistorico}
                    setOpen={setOpenHistorico}
                    dados={historicoVisitante} />
            }
            {editModal &&
                <ConfirmModal
                    open={editModal}
                    setOpen={setEditModal}
                    titleText={'Editar Visitante'}
                    text={'Deseja editar os dados do visitante?'}
                    confirmFunction={() => {
                        editarVisitante(visitantesDados)
                        setEditModal(false)
                    }}
                />
            }
            {openModalEditTag &&
                <OneModal
                    open={open}
                    setOpen={setOpenModalEditTag}
                    titleText='Editar tag'
                    paddingZero={true}
                >
                    <Grid xs={12}>
                        <iframe
                            src={`http://${window.location.hostname}/wsonePortaria/web/?chave=${activeCond.chave}&usuario=${user.id}&nome=${user.nome}&zoom=80&oneversao=1&idtag=${visitantesDados.id_tag}`}
                            width="550px"
                            height="620px"
                            frameBorder="0"
                        ></iframe>
                    </Grid>
                </OneModal>
            }

            {openModalAnexosVisitante &&
                <AnexosVisitante
                    open={openModalAnexosVisitante}
                    setOpen={setOpenModalAnexosVisitante}
                    titleText={nomeAnexoVisitante}
                    setImagemVisitante={setAnexoVisitante}
                    caminhoImagem={(() => {
                        // Sempre buscar o valor mais atualizado de visitantesDados
                        if (propriedadeImagemCapturada === 'IMAGEMDOCUMENTO') {
                            return getImagemDocumentoSrc(visitantesDados.imgDocumento || visitantesDados.IMAGEMDOCUMENTO, 'IMAGEMDOCUMENTO')
                        } else if (propriedadeImagemCapturada === 'IMAGEMDOCUMENTO2') {
                            return getImagemDocumentoSrc(visitantesDados.imgDocumento2 || visitantesDados.IMAGEMDOCUMENTO2, 'IMAGEMDOCUMENTO2')
                        }
                        return caminhoAnexoVisitante
                    })()}
                    propriedadeImagemCapturada={propriedadeImagemCapturada}
                />
            }

            <WebCam open={modalCam} setOpen={setModalCam} retornoFunc={fotoWebCam} cropActive={true} />

            {/* imagem */}
            <Grid xs={2} sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                marginRight: '5px',
                borderRadius: '10px',
                position: "relative"
            }}>
                {visitantesDados &&
                    <Grid container sx={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '100%',
                        borderRadius: '10px',
                        padding: '5px',
                        position: "relative",
                        border: '1px solid black',
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Box sx={{ width: '100%', height: '100%' }}>
                            <AvatarOne
                                src={imagemVisitante}
                                height={'auto'}
                                width={'auto'}
                                maxWidth={'100%'}
                                maxHeight={'100%'}
                                retrato={true}
                            />

                        </Box>

                        {!disabledComponents &&
                            <Box sx={{ width: '100%', height: '100%', position: 'absolute', zIndex: 2 }}>
                                <Tooltip title={"Adicionar imagem do computador!"}>
                                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', paddingRight: '17px', zIndex: '10', height: '50%' }}>
                                        <AddCircle cursor="pointer" sx={{ fontSize: '35px', color: 'green' }} onClick={() => {
                                            document.getElementById('file').click()
                                        }} />
                                        <input style={{ display: 'none' }} type="file" name="file" id="file" onChange={(e) => {
                                            const file = e.target.files[0]
                                            const reader = new FileReader()
                                            reader.readAsDataURL(file)
                                            reader.onload = () => {
                                                const base64 = reader.result
                                                setVisitantesDados({ ...visitantesDados, face: base64, gerarTag: true })
                                            }
                                            setImagemVisitante(URL.createObjectURL(file))
                                        }
                                        } />
                                    </Box>
                                </Tooltip>

                                {
                                    visitantesDados &&
                                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '25px', zIndex: 10, height: '50%', alignItems: "flex-end", paddingBlock: '3px', paddingBottom: '10px' }}>
                                        <BtnCapturarFacial />
                                    </Box>
                                }
                            </Box>
                        }

                    </Grid>
                }

            </Grid>
            <Grid xs container direction={'column'} gap={1} >
                {/* 1 linha */}
                <Grid container xs={12} gap={1}>
                    <LabelInput
                        name='cpf'
                        labelWidth={labelWidth}
                        inputWidth={inputWidth}
                        componentXl={2.5}
                        componentXs={12}
                        componentHeight={'fit-content'}
                        labelText={`${activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'}:`}
                        inputValue={visitantesDados && visitantesDados.cpf ? visitantesDados.cpf : ''}
                        inputChange={handleChangeVisitanteDados}
                        disabled={!criarNovoVisitante || (visitantesDados && visitantesDados.bloqueado)}
                        EndBtn={BuscaCPFComponent}
                        typographySx={TypographySx}
                        inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                    />

                    <LabelInput
                        name='nome'
                        labelWidth={labelWidth}
                        inputWidth={inputWidth}
                        componentHeight={'fit-content'}
                        labelText={'NOME:'}
                        inputValue={visitantesDados && visitantesDados.nome ? visitantesDados.nome + (visitantesDados.bloqueado ? ' (Bloqueado)' : '') : ''}
                        inputChange={handleChangeVisitanteDados}
                        disabled={!criarNovoVisitante || (visitantesDados && visitantesDados.bloqueado)}
                        maxLength={50}
                        typographySx={TypographySx}
                        inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                    />
                </Grid>
                {/* fim 1 linha */}

                {/* 2 linha */}
                <Grid container xs={12} gap={1}>
                    <LabelInput
                        name='NASCIMENTO'
                        type='date'
                        labelWidth={labelWidth}
                        inputWidth={inputWidth}
                        componentXl={2.5}
                        componentXs={12}
                        componentHeight={'fit-content'}
                        labelText={'NASC:'}
                        inputValue={visitantesDados && visitantesDados.NASCIMENTO ? visitantesDados.NASCIMENTO : ''}
                        inputChange={handleChangeVisitanteDados}
                        disabled={visitanteInfo || !criarNovoVisitante || (visitantesDados && visitantesDados.bloqueado)}
                        typographySx={TypographySx}
                        inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                    />

                    <LabelInput
                        name='CEP'
                        labelWidth={labelWidth}
                        inputWidth={inputWidth}
                        componentXl={2}
                        componentXs={12}
                        componentHeight={'fit-content'}
                        labelText={'CEP:'}
                        inputValue={visitantesDados && visitantesDados.CEP ? visitantesDados.CEP : ''}
                        inputChange={handleChangeVisitanteDados}
                        disabled={disabledComponents || (visitantesDados && visitantesDados.bloqueado)}
                        EndBtn={BuscarCepComponent}
                        typographySx={TypographySx}
                        inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                    />

                    <LabelInput
                        name='ENDERECO'
                        labelWidth={labelWidth}
                        inputWidth={inputWidth}
                        componentXl={5.5}
                        componentXs={12}
                        componentHeight={'fit-content'}
                        labelText={'END:'}
                        inputValue={visitantesDados && visitantesDados.ENDERECO ? visitantesDados.ENDERECO : ''}
                        inputChange={handleChangeVisitanteDados}
                        disabled={disabledComponents || (visitantesDados && visitantesDados.bloqueado)}
                        typographySx={TypographySx}
                        inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                    />
                    <LabelInput
                        name='NUMERO'
                        labelWidth={labelWidth}
                        inputWidth={inputWidth}
                        componentXl={false}
                        componentXs={12}
                        componentHeight={'fit-content'}
                        labelText={'Nº:'}
                        inputValue={visitantesDados && visitantesDados.NUMERO ? visitantesDados.NUMERO : ''}
                        inputChange={handleChangeVisitanteDados}
                        disabled={disabledComponents || (visitantesDados && visitantesDados.bloqueado) }
                        typographySx={TypographySx}
                        inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                    />
                </Grid>
                {/* fim 2 linha */}

                {/* 3 a 4 linhas */}
                <Grid xs gap={1} container direction={'row'} sx={{ height: '40%' }}>
                    {/* 1 oluna */}
                    <Grid xs={2.5} container gap={1} direction={'column'} sx={{ justifyContent: 'flex-start' }}>
                        <LabelInput
                            name='telefone'
                            labelWidth={labelWidth}
                            inputWidth={inputWidth}
                            componentXl={12}
                            componentXs={12}
                            componentHeight={'fit-content'}
                            labelText={'CEL:'}
                            inputValue={visitantesDados && visitantesDados.telefone ? visitantesDados.telefone : ''}
                            inputChange={handleChangeVisitanteDados}
                            disabled={disabledComponents || (visitantesDados && visitantesDados.bloqueado)}
                            typographySx={TypographySx}
                            inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                        />
                        <LabelInput
                            name='placa'
                            labelWidth={labelWidth}
                            inputWidth={inputWidth}
                            componentXl={12}
                            componentXs={12}
                            componentHeight={'fit-content'}
                            labelText={'PLACA:'}
                            inputValue={visitantesDados && visitantesDados.placa ? visitantesDados.placa : ''}
                            inputChange={handleChangeVisitanteDados}
                            disabled={disabledComponents || (visitantesDados && visitantesDados.bloqueado)}
                            typographySx={TypographySx}
                            inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                        />
                        <LabelSelect
                            name='ID_FUNCAO'
                            labelWidth={labelWidth}
                            inputWidth={inputWidth}
                            componentXl={12}
                            componentXs={12}
                            componentHeight={'fit-content'}
                            labelText={'TIPO:'}
                            inputValue={visitantesDados && visitantesDados.ID_FUNCAO ? visitantesDados.ID_FUNCAO : 'Visitante'}
                            inputChange={handleChangeVisitanteDados}
                            optionsSelect={[
                                { id: 'Visitante', descricao: 'Visitante' },
                                { id: 'Prestador Servico', descricao: 'Prestador Serviço' },
                                { id: 'Hospede', descricao: 'Hóspede' },
                                { id: 'Autorizado', descricao: 'Autorizado' }
                            ]}
                            disabled={disabledComponents || (visitantesDados && visitantesDados.bloqueado)}
                            inputSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                        />
                    </Grid>
                    {/* fim 1 coluna */}

                    {/* 2 coluna */}
                    <Grid xs={6} container gap={1} direction={'column'} sx={{ justifyContent: 'flex-start' }}>
                        <Grid xs={12} sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                            <Tabs
                                orientation='vertical'
                                value={tab}
                                onChange={(_, newValue) => setTab(newValue)}
                                indicatorColor='secondary'>
                                <Tab sx={{ height: '25%', minHeight: '25%', padding: '0px', marginBottom: '5px' }} label={<Typography sx={TypographySx}>OBS:</Typography>} />
                                {(activeCond.nome_doc1 || activeCond.nome_doc2 || activeCond.nome_doc3) &&
                                    <Tab sx={{ height: '25%', minHeight: '25%', padding: '0px', marginBottom: '5px' }} label={<Typography sx={TypographySx}>DOCS:</Typography>} />
                                }
                                <Tab sx={{ height: '25%', minHeight: '25%', padding: '0px', marginBottom: '5px' }} label={<Typography sx={TypographySx}>ANEXOS:</Typography>} />
                            </Tabs>
                            <TabPanel value={tab} index={0} inputWidth={inputWidth}>
                                <OneTextArea
                                    name='obs'
                                    value={visitantesDados && visitantesDados.obs ? visitantesDados.obs : ''}
                                    onChange={handleChangeVisitanteDados}
                                    autoScroll={true}
                                    newSx={{ color: visitantesDados && visitantesDados.bloqueado ? 'red' : 'black', backgroundColor: disabledComponents ? '#c9c7c7' : '#fff' }}
                                    readOnly={disabledComponents}
                                    disabled={visitantesDados && visitantesDados.bloqueado}
                                />
                            </TabPanel>
                            <TabPanel value={tab} index={1} inputWidth={inputWidth}>
                                <Grid container xs={12} gap={1} sx={{
                                    border: '2px solid #4b4b4b',
                                    borderRadius: '5px',
                                    padding: '5px'
                                }}>
                                    {activeCond.nome_doc1 &&
                                    <Grid xs={12} sx={{ height: 'fit-content', display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ width: labelWidth }}>
                                            <Typography sx={visitantesDados && visitantesDados.bloqueado ? { ...TypographySx, color: 'red' } : TypographySx}>
                                                {activeCond.doc1_obrigatorio ? `${activeCond.nome_doc1}*:` : `${activeCond.nome_doc1}:`}
                                            </Typography>
                                        </div>
                                        <div style={{ width: inputWidth }}>
                                            <OneDatePicker
                                                key={`validade_doc1-${visitantesDados && visitantesDados.nome != '' ? visitantesDados.nome : ''}`}
                                                name='validade_doc1'
                                                type='date'
                                                callback={handleChangeVisitanteDados}
                                                defaultValue={visitantesDados && visitantesDados.validade_doc1}
                                                newSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                                                disabled={visitantesDados && visitantesDados.bloqueado}
                                            />
                                        </div>
                                    </Grid>
                                    }
                                    {activeCond.nome_doc2 &&
                                    <Grid xs={12} sx={{ height: 'fit-content', display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ width: labelWidth }}>
                                            <Typography sx={visitantesDados && visitantesDados.bloqueado ? { ...TypographySx, color: 'red' } : TypographySx}>
                                                {activeCond.doc2_obrigatorio ? `${activeCond.nome_doc2}*:` : `${activeCond.nome_doc2}:`}
                                            </Typography>
                                        </div>
                                        <div style={{ width: inputWidth }}>
                                            <OneDatePicker
                                                key={`validade_doc2-${visitantesDados && visitantesDados.nome != '' ? visitantesDados.nome : ''}`}
                                                name='validade_doc2'
                                                type='date'
                                                callback={handleChangeVisitanteDados}
                                                defaultValue={visitantesDados && visitantesDados.validade_doc2}
                                                newSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                                                disabled={visitantesDados && visitantesDados.bloqueado}
                                            />
                                        </div>
                                    </Grid>
                                    }
                                    {activeCond.nome_doc3 &&
                                        <Grid xs={12} sx={{ height: 'fit-content', display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ width: labelWidth }}>
                                                <Typography sx={visitantesDados && visitantesDados.bloqueado ? { ...TypographySx, color: 'red' } : TypographySx}>
                                                    {activeCond.doc3_obrigatorio ? `${activeCond.nome_doc3}*:` : `${activeCond.nome_doc3}:`}
                                                </Typography>
                                            </div>
                                            <div style={{ width: inputWidth }}>
                                                <OneDatePicker
                                                    key={`validade_doc3-${visitantesDados && visitantesDados.nome != '' ? visitantesDados.nome : ''}`}
                                                    name='validade_doc3'
                                                    type='date'
                                                    callback={handleChangeVisitanteDados}
                                                    defaultValue={visitantesDados && visitantesDados.validade_doc3}
                                                    newSx={visitantesDados && visitantesDados.bloqueado ? { color: 'red' } : ''}
                                                    disabled={visitantesDados && visitantesDados.bloqueado}
                                                />
                                            </div>
                                        </Grid>
                                    }
                                </Grid>
                            </TabPanel>
                            <TabPanel value={tab} index={2} inputWidth={inputWidth}>
                                <Grid container xs={12} gap={1} sx={{
                                    border: '2px solid #4b4b4b',
                                    borderRadius: '5px',
                                    padding: '5px'
                                }}>
                                    <Grid container xs={12} gap={1}>
                                        <Grid xs sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ width: labelWidth }}>
                                                <Typography sx={TypographySx}>Doc 1:</Typography>
                                            </div>
                                            <div style={{ width: inputWidth }}>
                                                {(visitantesDados && visitantesDados.IMAGEMDOCUMENTO && visitantesDados.IMAGEMDOCUMENTO != '') || (visitantesDados && visitantesDados.imgDocumento && visitantesDados.imgDocumento != '')
                                                    ? (() => {
                                                        const doc1Src = getImagemDocumentoSrc(visitantesDados.imgDocumento || visitantesDados.IMAGEMDOCUMENTO, 'IMAGEMDOCUMENTO')
                                                        if (!doc1Src) { return null }
                                                        return (
                                                            <img
                                                                id='imgDocumento'
                                                                onClick={() => {
                                                                    setNomeAnexoVisitante('Documento 1')
                                                                    setCaminhoAnexoVisitante(doc1Src)
                                                                    setOpenModalAnexosVisitante(true)
                                                                    setPropriedadeImagemCapturada('IMAGEMDOCUMENTO')
                                                                }}
                                                                style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                                                                src={doc1Src} alt="Imagem do Documento"
                                                            />
                                                        )
                                                    })()
                                                    : (
                                                        <Box
                                                            id='imgDocumento'
                                                            onClick={() => {
                                                                setNomeAnexoVisitante('Documento 1')
                                                                setCaminhoAnexoVisitante('')
                                                                setOpenModalAnexosVisitante(true)
                                                                setPropriedadeImagemCapturada('IMAGEMDOCUMENTO')
                                                            }}
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                border: '2px dashed #ccc',
                                                                borderRadius: '5px',
                                                                cursor: 'pointer',
                                                                '&:hover': {
                                                                    borderColor: '#8A05BE',
                                                                    backgroundColor: '#f5f5f5'
                                                                }
                                                            }}
                                                        >
                                                            <Add sx={{ fontSize: '48px', color: '#8A05BE' }} />
                                                        </Box>
                                                    )}
                                            </div>
                                        </Grid>
                                        <Grid xs sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ width: labelWidth }}>
                                                <Typography sx={TypographySx}>Doc 2:</Typography>
                                            </div>
                                            <div style={{ width: inputWidth }}>
                                                {(visitantesDados && visitantesDados.IMAGEMDOCUMENTO2 && visitantesDados.IMAGEMDOCUMENTO2 != '') || (visitantesDados && visitantesDados.imgDocumento2 && visitantesDados.imgDocumento2 != '')
                                                    ? (() => {
                                                        const doc2Src = getImagemDocumentoSrc(visitantesDados.imgDocumento2 || visitantesDados.IMAGEMDOCUMENTO2, 'IMAGEMDOCUMENTO2')
                                                        if (!doc2Src) { return null }
                                                        return (
                                                            <img
                                                                id='imgDocumento2'
                                                                onClick={() => {
                                                                    setNomeAnexoVisitante('Documento 2')
                                                                    setCaminhoAnexoVisitante(doc2Src)
                                                                    setOpenModalAnexosVisitante(true)
                                                                    setPropriedadeImagemCapturada('IMAGEMDOCUMENTO2')
                                                                }}
                                                                style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                                                                src={doc2Src} alt="Imagem do Documento 2"
                                                            />
                                                        )
                                                    })()
                                                    : (
                                                        <Box
                                                            id='imgDocumento2'
                                                            onClick={() => {
                                                                setNomeAnexoVisitante('Documento 2')
                                                                setCaminhoAnexoVisitante('')
                                                                setOpenModalAnexosVisitante(true)
                                                                setPropriedadeImagemCapturada('IMAGEMDOCUMENTO2')
                                                            }}
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                border: '2px dashed #ccc',
                                                                borderRadius: '5px',
                                                                cursor: 'pointer',
                                                                '&:hover': {
                                                                    borderColor: '#8A05BE',
                                                                    backgroundColor: '#f5f5f5'
                                                                }
                                                            }}
                                                        >
                                                            <Add sx={{ fontSize: '48px', color: '#8A05BE' }} />
                                                        </Box>
                                                    )}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                        </Grid>
                    </Grid>
                    {/* fim 2 coluna */}

                    {/* 3 coluna */}
                    <Grid xs={1.5} container gap={1} direction={'column'} sx={{ justifyContent: 'flex-start' }}>
                        <Grid container xs={12} sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                            {/* <Grid container xs={12} sx={{ alignContent: 'center', justifyContent: 'center', padding: 0, margin: 0 }}> */}
                            <Tooltip title={'Editar Tag facial desse visitante'}>
                                <OneButton
                                    id="button"
                                    variant="contained"
                                    onClick={() => {
                                        handleEditarTag()
                                    }}
                                    IconStart={LocalOffer}
                                    newSx={{ fontSize: '11px', width: '100%', height: '40%', marginBottom: '5px', border: '1px solid black', color: 'black' }}
                                    disabled={!(visitantesDados && visitantesDados.tag && visitantesDados.tag != '')}
                                >
                                    <Typography sx={{ ...TypographySx, fontSize: '13px' }}>
                                    Editar Tag
                                    </Typography>
                                </OneButton>
                            </Tooltip>
                            {/* </Grid> */}
                            <Tooltip title={!visitanteInfo ? "Procure um visitante" : "Buscar histórico de acessos"}>
                                <Grid onClick={() => handleHistoricoVisitante()} xs={12} sx={{ height: '50%', display: 'flex', flexDirection: 'row' }}>
                                    <div style={{
                                        border: '1px solid black',
                                        height: '100%',
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: '5px',
                                        cursor: 'pointer'
                                    }}>
                                        <HourglassBottom sx={{ color: 'black' }} />
                                        <Typography sx={TypographySx}>
                                            Histórico
                                        </Typography>
                                    </div>
                                </Grid>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    {/* fim 3 coluna */}

                    {/* 4 coluna */}
                    <Grid xs container direction={'row'} sx={{ justifyContent: 'flex-end' }}>
                        {localizacaoImoveis.length > 0 && visitanteInfo &&
                            <Tooltip title={"Enviar a localização do imóvel para o visitante"}>
                                <OneButton
                                    id="button"
                                    variant="contained"
                                    onClick={() => {
                                        enviaLocalizacao(visitantesDados)
                                    }}
                                    IconStart={Place}
                                    newSx={{
                                        border: '1px solid black',
                                        fontSize: '11px',
                                        color: 'black',
                                        width: '100%',
                                        height: '40%',
                                        marginBottom: '5px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Typography sx={{ color: 'black', fontSize: '13px' }}>
                                        Localização
                                    </Typography>
                                </OneButton>
                            </Tooltip>
                        }
                        <Tooltip title={!visitanteInfo && !criarNovoVisitante ? "Procure ou adicione um visitante" : "Salvar / Adicionar"}>
                            <Box onClick={handleSalvarAdicionarVisitante}
                                sx={{
                                    border: '1px solid white',
                                    height: !localizacaoImoveis.length > 0 ? '100%' : '50%',
                                    width: '100%',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-around',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap',
                                    borderRadius: '5px',
                                    padding: '10px 3px',
                                    gap: 1,
                                    cursor: !visitanteInfo && !criarNovoVisitante ? 'default' : 'pointer',
                                    backgroundColor: !visitanteInfo && !criarNovoVisitante ? '#004d0a' : '#0FBB00'
                                }}>

                                {!localizacaoImoveis.length > 0 &&
                                    <ArrowCircleDown sx={{ color: 'white', fontSize: { xl: '2.5rem' } }} />
                                }

                                <Typography sx={{ color: 'white', fontSize: { lg: '0.6rem', xl: '0.8rem' }, display: { xs: 'none', lg: 'inline-block' } }}>
                                    Salvar / Adicionar
                                </Typography>

                            </Box>
                        </Tooltip>
                    </Grid>
                    {/* fim 4 coluna */}
                </Grid>
                {/* fim 3 linha */}
            </Grid>
        </Grid>
    )
}

export default VisitanteInfo
